import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { Task } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { fetchSubtasks } from '../api/tasksApi';

export function useTaskSubtasks(parentId: number): UseQueryResult<Task[]> {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['tasks', user?.id, parentId, 'subtasks'],
    queryFn: () => fetchSubtasks(parentId),
    enabled: user !== null,
  });
}
